// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"171e0758","453":"60ad47ce","732":"5715fdce"}[chunkId] + ".chunk.js";
};